module.exports = __webpack_public_path__ + "static/media/logo-verified-by-visa.04ff2a5c.svg";